// JS file for CategoryItem
